import { apiDealTypes, FieldConfig, PIPELINE_MAP } from 'model/deals.model';

export const additionalInformationFields: FieldConfig[] = [
  {
    name: 'dealDetails.outcome',
    label: 'Outcome',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.lossReason',
    label: 'Loss reason',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.passReason',
    label: 'Pass reason',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.competitor', label: 'Competitor', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.companyName',
    label: 'Company Name',
    type: 'autocomplete',
    autocompleteType: 'company',
    sm: 6,
  },
];

export const projectInfoFields: FieldConfig[] = [
  { name: 'dealDetails.projectType', label: 'Project type', type: 'select', xs: 6, sm: 6 },
  {
    name: 'dealDetails.entertainmentCrossover',
    label: 'Entertainment crossover',
    type: 'select',
    xs: 6,
    sm: 6,
  },
  {
    name: 'dealDetails.careerStageCheck',
    label: 'Career Stage Check',
    type: 'select',
    xs: 6,
    sm: 6,
  },
  { name: 'dealDetails.lg3AMsInvolved', label: 'LG/3AMs involved', type: 'checkbox', xs: 6, sm: 6 },
  { name: 'dealDetails.clientRole', label: 'Client role', type: 'select', xs: 6, sm: 6 },
  {
    name: 'dealDetails.clientOwnership',
    label: 'Client ownership (%)',
    type: 'number',
    xs: 6,
    sm: 6,
  },
  { name: 'dealDetails.3ASOwnership', label: '3AS ownership (%)', type: 'number', xs: 6, sm: 6 },
  { name: 'dealDetails.buyerPlatform', label: 'Buyer/Platform', type: 'text', xs: 6, sm: 6 },
];

export const financialFields: FieldConfig[] = [
  { name: 'dealDetails.dealValue', label: 'Deal value (gross)', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.commissionRate',
    label: 'Commission rate (%)',
    type: 'number',
    xs: 12,
    sm: 6,
  },

  { name: 'dealDetails.commissionValue', label: 'Commission value', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.dealStructure',
    label: 'Deal structure',
    type: 'select',
    xs: 12,
    sm: 6,
  },

  { name: 'dealDetails.equity', label: 'Equity/ownership (%)', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.backend', label: 'Backend', type: 'text', xs: 12, sm: 6 },

  {
    name: 'dealDetails.closeDate',
    label: 'Expected close date',
    type: 'date',
    xs: 12,
    sm: 12,
  },
];

export const dualRevenueFields: FieldConfig[] = [
  {
    name: 'dealDetails.talentFeeCommissionRate',
    label: 'Talent fee commission rate (%)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.talentFeeCommission',
    label: 'Talent fee commission',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.3ASProductionFee',
    label: '3AS production fee ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.total3ASRevenue',
    label: 'Total 3AS revenue',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.ownedRevenue', label: 'Owned revenue (%)', type: 'number', xs: 12, sm: 6 },
];

export const attributionTrackingFields: FieldConfig[] = [
  {
    name: 'dealDetails.leadershipSponsor',
    label: 'Leadership sponsor',
    type: 'text',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.source',
    label: 'Source',
    type: 'select',
    xs: 12,
    sm: 6,
  },

  { name: 'dealDetails.partnerAccount', label: 'Partner account', type: 'text', xs: 12, sm: 6 },
  { name: 'dealDetails.partnerContact', label: 'Partner contact', type: 'text', xs: 12, sm: 6 },

  {
    name: 'dealDetails.daysInCurrentStage',
    label: 'Days in current stage',
    type: 'text',
    xs: 12,
    sm: 12,
  },
];

export const getDealTypeKey = (pipelineType: string): apiDealTypes | null => {
  if (!pipelineType) return null;

  const apiKey = (Object.keys(PIPELINE_MAP) as apiDealTypes[]).find(
    (key) => PIPELINE_MAP[key] === pipelineType,
  );

  return apiKey || null;
};
